import React from 'react';
import styles from './StoreProfileTop.module.scss';
import Avatar from 'components/shared/Avatar';
import Tabs from 'components/shared/Tabs';
import { CircleFlag } from 'react-circle-flags';
import { useTranslation } from 'react-i18next';
import Button from 'components/shared/Button';

interface StoreProfileTopProps {
    data: any;
    refetch: () => void;
    tab: number;
    setTab: (tab: number) => void;
    tabs: Array<{ id: number; title: string }>;
}

const StoreProfileTop: React.FC<StoreProfileTopProps> = ({
                                                             data,
                                                             tab,
                                                             setTab,
                                                             tabs,
                                                         }) => {
    const { t } = useTranslation() as any;

    const getMedia = (link: string) => {
        if (!link) {
            return '';
        }

        if (link.slice(-3) === 'mp4' || link.slice(-3) === 'mov' || link.slice(-3) === '3gp') {
            return <video src={link} muted autoPlay loop />;
        }

        return <img src={link} alt={data?.store_name} />;
    };

    return (
        <div className={styles.container}>
            <div className={styles.profile}>
                {/* Background Image/Video */}
                {data?.bg_cover && (
                    <div className={styles.profileImg}>{getMedia(data?.bg_cover)}</div>
                )}

                {/* Avatar */}
                <div className={styles.avatarRow} style={{ marginBottom: '12px' }}>
                    {data?.avatar && (
                        <Avatar
                            className={styles.avatar}
                            image={data?.avatar}
                            isExpert={false}
                        />
                    )}
                </div>

                {/* Country/Location */}
                <div className={styles.location} style={{ marginBottom: '8px' }}>
                    {data?.country && data?.country?.iso ? (
                        <div className={styles.countryRow}>
                            <CircleFlag
                                countryCode={data?.country?.iso?.toLowerCase()}
                                height="20"
                                className={styles.flag}
                            />
                            <span className={styles.countryName}>{data?.country?.country_name}</span>
                        </div>
                    ) : null}
                </div>

                {/* Store Name */}
                <div className={styles.name}>{data?.store_name}</div>

                {/* See Products CTA Button */}
                <div className={styles.profileActions} style={{ marginTop: '16px', marginBottom: '20px' }}>
                    <Button
                        darkGreen
                        className={styles.seeProductsButton}
                        onClick={() => setTab(2)}
                    >
                        {t('See Products')}
                    </Button>
                </div>

                {/* Spacer to push tabs down */}
                <div className={styles.spacer}></div>

                {/* Tabs */}
                <Tabs className={styles.tabs} value={tab} items={tabs} onSelect={setTab} inline white />
            </div>
        </div>
    );
};

export default StoreProfileTop;